import React from "react";
import Slide from "@material-ui/core/Slide";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import Snackbar from "@material-ui/core/Snackbar";
import LogManager from "../common/LogManager";
import type { LogComponentData, LogType } from "../common/LogManager";
import styles from './SnackComponent.module.scss';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import CancelIcon from "@material-ui/icons/Cancel";

/**
 * This component is controlled by the LogManager service.
 * We only need to place an instance of this component at the top level component of the app
 * and we don't need props or attributes to show the messages
 */

interface SnackComponentState {
    type: LogType;
    message: string;
    visible: boolean;
    /** null mantiene el mensaje abierto hasta que se cierra a mano. */
    autoHideDuration: number | null;
}

class SnackComponent extends React.Component<object, SnackComponentState> {
    defaultAutoHideDuration = 6000;

    constructor(props: object) {
        super(props);

        this.state = {
            type: LogManager.TYPE_ERROR,
            message: '',
            visible: false,
            autoHideDuration: this.defaultAutoHideDuration,
        }

        this.handleCloseLog = this.handleCloseLog.bind(this);
        this.handleDeleteLog = this.handleDeleteLog.bind(this);
        this.handleLogEvent = this.handleLogEvent.bind(this);
        this.handleUnlockLog = this.handleUnlockLog.bind(this);

        LogManager.setLogHandler(this.handleLogEvent, this.handleCloseLog);
    }

    /**
     * method called from snackbar transition to close snackbar
     */
    handleLogEvent(data: LogComponentData): void {
        const  {visible, message, type, block} = data;
        this.setState({
            visible,
            message,
            type,
            autoHideDuration: block ? null : this.defaultAutoHideDuration,
        })
    }

    /**
     * method called from snackbar transition to close snackbar
     */
    handleCloseLog(): void {
        const message = this.state.message;
        const type = this.state.type;
        this.setState({
            visible: false,
            message,
            type,
            autoHideDuration: this.defaultAutoHideDuration,
        })
    }

    /**
     * method called from snackbar transition when snackbar finish closing
     */
    handleDeleteLog(): void {
        LogManager.deleteLog();
    }

    /**
     * method called from snackbar to close locked snackbar
     */
    handleUnlockLog(): void {
        LogManager.unlock();
    }

    render() {
        let classList = styles.snackBar + ' snackbar';
        if (!this.state.visible) {
            classList += ' ' + styles.hide;
        }

        return (
            <Snackbar open={this.state.visible}
                      autoHideDuration={this.state.autoHideDuration}
                      anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center',
                      }}
                      classes={{ anchorOriginBottomCenter: styles.snackBarAnchor }}
                      TransitionComponent={Slide}
                      onClose={this.handleCloseLog}
                      TransitionProps={{
                          onExited: this.handleDeleteLog
                      }}
                      className={classList}
                      ClickAwayListenerProps={{mouseEvent: false, touchEvent: false}}
            >
                <SnackbarContent
                        className={`${styles[this.state.type]} ${styles.snackBarContent}`}
                        message={
                            this.state.type === LogManager.DIRECTION_INFO ?
                                <div>
                                    <DirectionsWalkIcon className={styles.walkicon} />
                                    <span>{this.state.message}</span>
                                    <CancelIcon className={styles.closeicon} onClick={this.handleUnlockLog}/>
                                </div>
                                :
                                <div>{this.state.message}</div>
                    }>

                </SnackbarContent>
            </Snackbar>
        )
    }
}

export default SnackComponent;
